import React from 'react';
import { useNavigate } from 'react-router-dom';

const BackButton = () => {
  const navigate = useNavigate();

  return (
    <button 
      onClick={() => navigate(-1)} 
      className="flex items-center gap-2 mb-6 font-body-md text-on-surface-variant hover:text-primary transition-colors group w-fit"
    >
      <span className="material-symbols-outlined group-hover:-translate-x-1 transition-transform">arrow_back</span>
      <span>Go Back</span>
    </button>
  );
};

export default BackButton;
